import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

export const getChangesMessage = (opportunities: any, sendData: any) => {
  const messages = [];

  const startDate = dayjs(sendData.startDate).utc();
  const startOldDate = dayjs(opportunities.startDate).utc();

  const endDate = dayjs(sendData.endDate).utc();
  const endOldDate = dayjs(opportunities.endDate).utc();

  const dateOld = startOldDate.format('MMMM D');
  const dateNew = startDate.format('MMMM D');

  if (dateOld !== dateNew) {
    messages.push(`Date has been changed from ${dateOld} to ${dateNew}`);
  }

  const srtTimeOld = startOldDate.format('hh:mm A');
  const startTimeNew = startDate.format('hh:mm A');
  if (srtTimeOld !== startTimeNew) {
    messages.push(`Start Time has been changed from ${srtTimeOld} to ${startTimeNew}`);
  }

  const endTimeOld = endOldDate.format('hh:mm A');
  const endTimeNew = endDate.format('hh:mm A');
  if (endTimeNew !== endTimeOld) {
    messages.push(`End Time has been changed from ${endTimeOld} to ${endTimeNew}`);
  }

  if (opportunities.address !== sendData.address) {
    messages.push(`Address has been changed from ${opportunities.address} to ${sendData.address}`);
  }

  return messages.join('\n');
};
